// Central data-testid constants for DYNICTY v2.1 landing page.
export const NAV = {
  root: "site-navbar",
  logo: "navbar-logo",
  linkHome: "navbar-link-home",
  linkFeatures: "navbar-link-features",
  linkTemplates: "navbar-link-templates",
  linkHowItWorks: "navbar-link-how-it-works",
  linkPricing: "navbar-link-pricing",
  linkFaq: "navbar-link-faq",
  ctaContact: "navbar-cta-contact",
  mobileMenu: "navbar-mobile-menu-button",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  primaryCta: "hero-primary-cta-lihat-contoh",
  secondaryCta: "hero-secondary-cta-cara-kerja",
};

export const PROBLEMS = { section: "problems-section", card: "problem-card" };
export const PARADIGM = { section: "paradigm-section" };
export const SOLUTION = { section: "solution-section" };
export const HOW = { section: "how-it-works-section", step: "how-step" };
export const TEMPLATES = {
  section: "template-showcase-section",
  card: "template-category-card",
  preview: "template-preview-button",
};
export const FEATURES = {
  section: "features-section",
  card: "feature-card",
};
export const COMPARE = { section: "compare-section" };
export const PRICING = {
  section: "pricing-section",
  card: "pricing-plan-card",
  cta: "pricing-plan-cta",
};
export const ADDONS = {
  section: "addons-section",
  card: "addon-card",
  cta: "addon-cta",
};
export const CUSTOM_WEB = {
  section: "custom-web-app-section",
  cta: "custom-web-app-cta",
};
export const FAQ = { section: "faq-section", item: "faq-item" };
export const FINAL_CTA = { section: "final-cta-section", cta: "final-cta-contact" };
export const FOOTER = { root: "site-footer" };

export const CONTACT = {
  root: "contact-page",
  form: "contact-form",
  inputName: "contact-input-name",
  inputBusiness: "contact-input-business",
  inputEmail: "contact-input-email-wa",
  inputPlan: "contact-input-plan",
  inputMessage: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-state",
  error: "contact-error-message",
};
